/** @format */

import { useContext, useState } from "react";
import { webEntryPasswordValidate, confirmPasswordValidate } from "../validators/publicValidator";
import { Context } from "../stores/Provider";
import { getSession, setSession } from "../sessionStorage/sessionStorageMethod";
import { passCheck } from "../function/passCheck";
import { PostMethod } from "../api/Api";
import { initApiResponse } from "../constance/constance";
import { initApiModelType, redirectUpdatePasswordRequestType } from "../constance/typeModel";
import { setIsLoading } from "../function/setIsLoading";
import { redirectLogoutAbnormalFunction } from "../function/logoutAbnormalFunction";

// 値には entry_id を保存し、同じタブで別の申込のリダイレクトが来た場合に誤判定しないようにする
export const PASSWORD_REGISTERED_KEY = "password_registered";

const useRedirectPasswordHooks = (navigateByAgent: Function) => {
  const [pass, setPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [ErrwebEntryMsg, setwebEntryErrMsg] = useState("");
  const [ErrConfirmMsg, setConfirmErrMsg] = useState("");
  const { state, dispatch } = useContext(Context);
  const userInfoData = getSession("user");
  const [passCheckState, setPassCheckState] = useState<{ msg: string; score: number }>({ msg: "", score: 0 });
  const [isRegistered, setIsRegistered] = useState(
    () => getSession(PASSWORD_REGISTERED_KEY) === userInfoData?.entry_id,
  );

  const setPassHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setPassCheckState(passCheck(e.target.value, []));
    setPass(e.target.value);
  };
  const setConfirmPassHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    setConfirmPass(e.target.value);
  };

  // Bカートとそれ以外の表記対応
  const zAccount = state.zAccount;

  const navigateConfirm = async () => {
    let response: initApiModelType<undefined> = initApiResponse;
    const confirmPasswordVal = confirmPasswordValidate(pass, confirmPass);

    // バリデーション処理
    setwebEntryErrMsg("");
    setConfirmErrMsg("");
    const webEntryPasswordVal = webEntryPasswordValidate(pass);

    if (webEntryPasswordVal.message !== "") {
      return setwebEntryErrMsg(webEntryPasswordVal.message);
    }
    if (confirmPasswordVal.message !== "") {
      return setConfirmErrMsg(confirmPasswordVal.message);
    }
    const data = {
      email: userInfoData.email,
      password: pass,
      entry_id: userInfoData.entry_id,
    };
    //ローディング画面開始
    setIsLoading(true, dispatch);
    //API通信
    response = await PostMethod<redirectUpdatePasswordRequestType, undefined>(data, "/redirect_update_password");
    // リダイレクト利用者は本パスワード未登録のため、ログイン画面ではなくリダイレクト用タイムアウト画面へ遷移する
    if (response.code === 401) {
      setIsLoading(false, dispatch);
      redirectLogoutAbnormalFunction(response, dispatch, navigateByAgent, state.agentPath, state.zAccount);
      return;
    }

    return response;
  };

  const markRegistered = () => {
    setSession(PASSWORD_REGISTERED_KEY, userInfoData.entry_id);
    setIsRegistered(true);
  };

  const normal = () => {
    dispatch({
      type: "set-user-data",
      payload: {
        web_entry_password: pass,
      },
    });
    setSession("web_entry_password", pass);
    markRegistered();
    setIsLoading(false, dispatch);
    navigateByAgent("/redirect_confirm");
  };

  const abnormal = (response: initApiModelType<undefined>) => {
    setIsLoading(false, dispatch);
    // 別タブなどで登録済みだった場合も、この画面を登録済み表示に切り替える
    if (response.code === 409) {
      markRegistered();
      return;
    }
    return navigateByAgent("/redirect_password");
  };

  const navigateConfirmRegistered = () => {
    navigateByAgent("/redirect_confirm");
  };

  return {
    setPassHandler,
    setConfirmPassHandler,
    ErrwebEntryMsg,
    ErrConfirmMsg,
    navigateConfirm,
    userInfoData,
    passCheckState,
    normal,
    abnormal,
    zAccount,
    isRegistered,
    navigateConfirmRegistered,
  };
};

export default useRedirectPasswordHooks;
